<template>
  <a-modal
    title="请编辑淘汰的理由"
    okText="保存"
    @ok="save"
    v-model="visible"
    :width="650"
    class="showMessage"
    wrapClassName="recommend-modal"
  >
    <template>
      <div class="listtitle">编辑淘汰理由(已选{{ selectedTags.length }}个)</div>
      <!-- <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-col class="col">
          <template>
            <a-textarea
              placeholder="请填写淘汰理由"
              :rows="4"
              v-model="reason"
            />
          </template>
        </a-col>
      </a-row>
      <div class="salary" v-show="showPrice">
        候选人要求最少（月）：
        <a-input
          placeholder="请输入金额"
          size="small"
          class="salaryInput"
          v-model="salary"
        />
        &nbsp;k
      </div> -->
      <a-form class="order-form" :form="form">
        <a-form-item class="textarea-limit">
          <a-textarea
            placeholder="请填写淘汰的原因"
            :rows="6"
            v-decorator="[
              'reason'
            ]"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="候选人年龄" v-if="selectedTags.indexOf('年龄太大') > -1" v-bind="formItemsLayout">
          <a-input
            :style="{ display: 'inline-block', width: 'calc(30% - 12px)' }"
            v-decorator="[
              'age_min',
              { rules: [{ required: true, message: '请填写年龄' }] }
            ]"
          >
          </a-input>
          <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">-</span>
          <a-input
            :style="{ display: 'inline-block', width: 'calc(30% - 12px)' }"
            v-decorator="[
              'age_max',
              { rules: [{ required: true, message: '请填写年龄' }] }
            ]"
          >
          </a-input>
          <span style="padding-left: 10px;">岁</span>
        </a-form-item>
        <a-form-item label="候选人学历" v-if="selectedTags.indexOf('学历不符') > -1">
          <a-radio-group
            :options="educationData"
            v-decorator="[
              `education_id`,
              { rules: [{ required: true, message: '请选择学历！' }] }
            ]"
          />
        </a-form-item>
        <a-form-item label="候选人薪资要求" v-if="selectedTags.indexOf('薪酬要求太高') > -1" v-bind="formItemsLayout">
          <a-input
            :style="{ display: 'inline-block', width: 'calc(30% - 12px)' }"
            v-decorator="[
              'expected_monthly_salary_min',
              { rules: [{ required: true, message: '请填写年龄' }] }
            ]"
          >
          </a-input>
          <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">-</span>
          <a-input
            :style="{ display: 'inline-block', width: 'calc(30% - 12px)' }"
            v-decorator="[
              'expected_monthly_salary_max',
              { rules: [{ required: true, message: '请填写年龄' }] }
            ]"
          >
          </a-input>
          <span style="padding-left: 10px;">K/月</span>
        </a-form-item>

        <a-form-item label="候选人学校" v-if="selectedTags.indexOf('学校不符') > -1" v-bind="formItemsLayout">
          <a-radio-group
            :options="[
              { label: '211/985', value: '1' },
              { label: '海归', value: '2' },
              { label: '统招本科', value: '3' },
            ]"
            v-decorator="[
              `school_id`,
              { rules: [{ required: true, message: '请选择学校' }] }
            ]"
          />
        </a-form-item>
        <a-form-item label="候选人性别" v-bind="formItemsLayout" v-if="selectedTags.indexOf('性别不符') > -1">
          <a-radio-group 
            v-decorator="['gender_id',{ rules: [{ required: true, message: '请选择性别' }] }]"
            >
            <a-radio value="1">
              只要男的
            </a-radio>
            <a-radio value="2">
              只要女的
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="候选人工作城市" v-bind="formItemsLayout" v-if="selectedTags.indexOf('工作地点不符') > -1">
          <a-cascader
            changeOnSelect
            v-decorator="['city_id',{ rules: [{ required: true, message: '请选择工作地点' }] }]"
            :options="options"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="请选择城市"
            style="display:block;"
            @click="getOptions"
          ></a-cascader>
        </a-form-item>

        <a-form-item label="候选人工作经验" v-bind="formItemsLayout" v-if="selectedTags.indexOf('工作经验不符') > -1">
          <a-radio-group
            :options="workExperienceData"
            v-decorator="[
              `working_years`,
              { rules: [{ required: true, message: '请选择工作经验！' }] }
            ]"
          />
        </a-form-item>
        
        <a-form-item label="候选人到岗时间" v-bind="formItemsLayout" v-if="selectedTags.indexOf('到岗时间太长') > -1">
          <a-radio-group 
            v-decorator="['entry_time_id',{ rules: [{ required: true, message: '请选择到岗时间' }] }]"
            >
            <a-radio value="1">
              随时
            </a-radio>
            <a-radio value="2">
              7天
            </a-radio>
            <a-radio value="3">
              15天
            </a-radio>
            <a-radio value="4">
              30天
            </a-radio>
            <a-radio value="5">
              30天以上
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="候选人当前薪酬" v-if="selectedTags.indexOf('薪酬造假') > -1" v-bind="formItemsLayout">
          <a-input
            :style="{ display: 'inline-block', width: 'calc(30% - 12px)' }"
            v-decorator="[
              'current_salary_min',
              { rules: [{ required: true, message: '请填写当前薪酬' }] }
            ]"
          >
          </a-input>
          <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">-</span>
          <a-input
            :style="{ display: 'inline-block', width: 'calc(30% - 12px)' }"
            v-decorator="[
              'current_salary_max',
              { rules: [{ required: true, message: '请填写当前薪酬' }] }
            ]"
          >
          </a-input>
          <span style="padding-left: 10px;">K/月</span>
        </a-form-item>

      </a-form>
      <div class="listtitle">请选择标签</div>
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <template v-for="tag in tags">
          <a-checkable-tag
            :key="tag"
            class="tag"
            :checked="selectedTags.indexOf(tag) > -1"
            @change="checked => handleChange(tag, checked)"
          >
            {{ tag }}
          </a-checkable-tag>
        </template>
      </a-row>
    </template>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "suitable",
  props: ["authorized_id", "getResumeList"],

  data() {
    return {
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16, offset: 1 },
        },
      },
      tags: [
        "学历不符",
        "年龄太大",
        "薪酬要求太高",
        "学校不符",
        "性别不符",
        "候选人级别不够",
        "工作地点不符",
        "工作经验不符",
        "软性方面不达标",
        "工作经历与岗位不匹配",
        "对加班比较抗拒",
        "到岗时间太长",
        "工作经历造假",
        "薪酬造假",
      ],
      selectedTags: [],
      visible: false,
      salary: undefined,
      reason: undefined,
      showPrice: false,
      options: [],
      workExperienceData: [
        { label: "不限", value: "0" },
        { label: "1年以下", value: "1" },
        { label: "1-3年", value: "2" },
        { label: "3-5年", value: "3" },
        { label: "5-10年", value: "4" },
        { label: "10-15年", value: "5" },
        { label: "15年以上", value: "6" }
      ],
      educationData: [
        { label: "不限", value: "0" },
        { label: "博士", value: "1" },
        { label: "MBA/EMBA", value: "2" },
        { label: "硕士", value: "3" },
        { label: "本科", value: "4" },
        { label: "大专", value: "5" },
        { label: "高中/中专", value: "6" }
      ],
    };
  },
  methods: {
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
      this.options.forEach(item => {
        item.children.forEach( _item =>{
          delete _item.children;
        })
      })
    },
    save() {
      console.log(
        this.selectedTags.join(),
        this.salary,
        this.reason,
        this.authorized_id
      );
      this.form.validateFields( (err, values) => {
        if (!err) {
          this.loading = true;
          console.log(values);
          values.city_id = values.city_id ? values.city_id[1] : '';
          let params = {
            recommend_result_id: this.recommend_result_id,
            reasons: this.selectedTags.join(),
            other_reasons: this.reason,
            ...values
          };
          Api.hunter.rejectRecommond(params).then(res => {
            console.log(res);
            if (res) {
              this.$message.success("提交成功");
              this.close();
              this.$emit("ok");
            } else {
              this.$message.error("提交失败");
            }
          });
        }
      })
      
    },
    show(recommend_result_id) {
      console.log(recommend_result_id, 'recommend_result_id');
      this.visible = true;
      this.recommend_result_id = recommend_result_id;
    },
    close() {
      this.selectedTags = [];
      this.salary = undefined;
      this.reason = undefined;
      this.params = {};
      this.visible = false;
    },
    handleChange(tag, checked) {
      const { selectedTags } = this;
      const nextSelectedTags = checked
        ? [...selectedTags, tag]
        : selectedTags.filter(t => t !== tag);
      console.log("You are interested in: ", nextSelectedTags);
      if (nextSelectedTags.indexOf("薪酬要求太高") == -1) {
        this.showPrice = false;
      } else {
        this.showPrice = true;
      }
      this.selectedTags = nextSelectedTags;
    }
  }
};
</script>

<style lang="scss">
.showMessage {
  .ant-modal-title {
    text-align: center;
  }
  .listtitle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .row-content {
    margin-left: 10px;
    .col {
      width: 100%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
    .tag {
      line-height: 30px;
      padding: 0 15px;
      height: 30px;
      font-size: 12px;
      border-radius: 4px;
      margin-bottom: 12px;
      border: 1px solid rgba(220, 223, 230, 1);
    }
  }
  .salaryInput {
    display: inline-block;
    width: 100px;
  }
}
</style>
